import React, { useState, useEffect, useRef } from 'react';
import { Col, Typography, Row, Card, Button, Modal, Layout } from 'antd';
import styled from 'styled-components';
import 'react-simple-keyboard/build/css/index.css';
import { isMobileOnly } from 'react-device-detect';
import { ImgButton } from 'src/components/Header/toolHeaderstyle';
import { useHistory } from 'react-router-dom';
import { CloseCircleOutlined } from '@ant-design/icons';
import FullScreenButton from 'src/components/common/FullScreenButton';
const { Header: HeaderWrapper } = Layout;
const { Title } = Typography;

const MainBlock = styled.div`
  padding: 10px;
  margin-top: 10px;
  background: #fff;
  height: calc(100vh - 94px);
`;

const TotalBox = styled.span`
  color: rgb(255, 122, 27);
  border: 1px solid #6b5c5c;
  padding: 5px 10px;
  border-radius: 5px;
`;

const InterpretationPage = ({ onClickGoback, data = [], dataUserStudy, handleSaveExit }) => {
  const [total, setTotal] = useState(data.length);
  const [done, setDone] = useState(0);
  const [userAnswers, setUserAnswers] = useState([]);
  const [answerSheet, setAnswerSheet] = useState([]);
  const [currentInputValue, setCurrentInputValue] = useState([]);
  const firstInputRef = useRef(null);
  const history = useHistory();
  useEffect(() => {
    if (data.length > 0) {
      setUserAnswers(Array(data.length).fill(''));
    }
  }, [data]);
  useEffect(() => {
    if (data.length > 0 && data[done].eng) {
      const amount = data[done].eng.split('/').length;
      setCurrentInputValue(Array(amount).fill(''));
    }
  }, [data, done]);
  const handleChangeInput = (value, indx) => {
    setCurrentInputValue((prev) => {
      const newValues = [...prev];
      newValues[indx] = value;
      return newValues;
    });
  };
  console.log(dataUserStudy, 'dataUserStudy');

  useEffect(() => {
    if (
      dataUserStudy &&
      dataUserStudy.getUserStudyCompleteList &&
      dataUserStudy.getUserStudyCompleteList[0]?.user_study_answer?.length >= 0
    ) {
      const lastStudyData = dataUserStudy.getUserStudyCompleteList[0]?.user_study_answer;
      const lastIdx = lastStudyData.findIndex((v) => v.user_answer === '');
      const tmpuserAnswers =[...userAnswers]
      const tmp = data.map((e,i) => {
        let findAnswer = lastStudyData.find((a) => a.question_no === e.no);
        tmpuserAnswers[i] = findAnswer && findAnswer.user_answer ? findAnswer.user_answer : ''
        return {
          question_no: e.no,
          user_answer: findAnswer && findAnswer.user_answer !== '' ? findAnswer.user_answer : '',
          is_correct: findAnswer ? findAnswer.is_correct : '0',
        };
      });
      setUserAnswers(tmpuserAnswers)
      setAnswerSheet(tmp);
      setDone(lastIdx === -1 ? 0 : lastIdx);
    } else {
      const tmp = data.map((e) => {
        return {
          question_no: e.no,
          user_answer: '',
        };
      });
      setAnswerSheet(tmp);
    }
  }, [dataUserStudy, data]);

  useEffect(() => {
    const t = setTimeout(() => {
      firstInputRef.current?.focus();
      firstInputRef.current?.select(); // 기존 값이 있으면 전체 선택
    }, 0);
    return () => clearTimeout(t);
  }, [done]);
  const goNextIndx = () => {
    const currentAnswer = currentInputValue.join(' / ');
    const tmp = [...answerSheet];
    tmp[done].user_answer = currentAnswer;
    tmp[done].is_correct = '1';
    setAnswerSheet(tmp);
    setUserAnswers((prev) => {
      const next = [...prev];
      next[done] = currentAnswer; // 1) 항상 먼저 저장

      const isLast = done === data.length - 1;

      if (isLast) {
        const recordingData = next
          .map((answer, index) => `<div>${data[index]?.eng}</div><div>${answer}</div>${index < next.length - 1 ? '<br/>' : ''}`)
          .join('');

        if (onClickGoback) {
          Modal.info({
            content: 'Finished all the questions.',
            onOk: () =>
              onClickGoback({
                recording_data: recordingData,
                user_answers:answerSheet
              }),
          });
        }
      } else {
        // 3) 마지막이 아니면 다음 문제로 이동
        setDone((d) => d + 1);
      }

      return next;
    });
  };
  const handleCloseClick = () => {
    Modal.confirm({
      icon: null,
      title: 'Exit',
      content: (
        <Title level={4} style={{ textAlign: 'center', lineHeight: 2 }}>
          학습이 완료되지 않았습니다. <br /> 종료하면 지금 학습하던 문제부터 <br />
          이어서 학습합니다. <br /> 종료 하시겠습니까?
        </Title>
      ),
      onOk: () => {
        handleSaveExit({ user_answers: answerSheet });
        history.push('/');
      },
    });
  };
  return (
    <>
      <HeaderWrapper
        style={{
          background: '#fff',
          paddingLeft: 10,
          paddingRight: 10,
          display: 'flex',
          justifyContent: 'space-between',
          position: 'relative',
          width: '100%',
          height: isMobileOnly && 50,
          lineHeight: isMobileOnly && '50px',
        }}
      >
        <div style={{ paddingTop: 10 }}>
          <Title level={2} style={{ marginLeft: 20, textTransform: 'capitalize', fontSize: isMobileOnly && 20 }}>
            Translation
          </Title>
        </div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {isMobileOnly && (
            <div style={{ backgroundColor: '' }}>
              <FullScreenButton
                element={<ImgButton className="header-btn" src="/images/fullscreen_blue.png" alt="back arrow in header" />}
                activeElement={<ImgButton className="header-btn" src="/images/fullscreenExit_blue.png" alt="back arrow in header" />}
              />
            </div>
          )}
          <div key="close" onClick={handleCloseClick}>
            <span style={{ color: '#999', cursor: 'pointer' }}>
              <CloseCircleOutlined
                style={{
                  marginRight: 20,
                  verticalAlign: 'middle',
                  fontSize: 25,
                  color: '#424242',
                }}
                key="close"
              />
            </span>
          </div>
        </div>
      </HeaderWrapper>
      <Col className="quiz-fluid-container" span={24} style={{ textAlign: 'left', margin: 0 }}>
        <MainBlock className="quiz-fluid-scroll">
          <Row gutter={[24, 16]} style={{ padding: 10 }}>
            <Col className="quiz-heading" span={16}>
              <Row gutter={[24, 16]} style={{ margin: 0 }}>
                <Col className="quiz-heading-containt" span={24} style={{ padding: 10, paddingLeft: 10 }}>
                  <Title level={2} ellipsis>
                    <span style={{ color: '#065aa9', marginLeft: 10, fontSize: isMobileOnly && '16px' }}>
                      Read the sentence and write the meaning of each part.
                    </span>{' '}
                  </Title>
                </Col>
              </Row>
            </Col>
            <Col
              className="quiz-heading-listing"
              span={8}
              style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', paddingRight: 10 }}
            >
              <Title level={4} style={{ margin: 0, marginLeft: 10, marginRight: 10 }}>
                <TotalBox>
                  {done + 1} / {total}
                </TotalBox>
              </Title>
              <Button disabled={currentInputValue.some((e) => !e)} onClick={goNextIndx} type="primary" value="large">
                Next
              </Button>
            </Col>
          </Row>
          <Row gutter={[24, 16]} style={{ padding: 10, display: 'flex', flexDirection: 'column' }}>
            <Col
              className={isMobileOnly ? 'word-board imagequizspeaker middle-box-mobile' : 'word-board imagequizspeaker'}
              // span={10}
              style={{ padding: 10, display: 'flex', flexDirection: 'column', justifyContent: 'space-evenly', alignItems: 'flex-start' }}
            >
              <Card
                style={{ width: '100%', borderRadius: 20, boxShadow: '10px 10px 5px 5px rgba(95, 77, 99, 0.5)', display: 'flex' }}
                bodyStyle={{ background: '#fff', borderRadius: 20, minHeight: '150px', display: 'flex', cursor: 'default' }}
                hoverable
                loading={false}
              >
                <p
                  style={{
                    width: '100%',
                    borderRadius: 20,
                    background: '#efefef',
                    fontSize: 20,
                    margin: 0,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    overflowY: 'auto',
                    padding: 10,
                  }}
                  dangerouslySetInnerHTML={{ __html: data[done]?.eng }}
                ></p>
              </Card>
            </Col>
            <Col
              className="word-board-option"
              // span={14}
              style={{
                padding: '0 40px',
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                flexDirection: 'column',
              }}
            >
              <Title
                level={4}
                style={{
                  width: '100%',
                  background: '#c0daf1',
                  marginLeft: 10,
                  padding: 10,
                  borderRadius: 10,
                  display: 'flex',
                  justifyContent: 'space-around',
                  alignItems: 'center',
                }}
              >
                {currentInputValue.map((_, indx) => (
                  <>
                    <input
                      key={indx}
                      ref={indx === 0 ? firstInputRef : null}
                      value={currentInputValue[indx]}
                      onChange={(e) => {
                        handleChangeInput(e.target.value, indx);
                      }}
                      style={{ width: '30%' }}
                    />
                    {indx === currentInputValue.length - 1 ? '' : <span>/</span>}
                  </>
                ))}
              </Title>
            </Col>
          </Row>
        </MainBlock>
      </Col>
    </>
  );
};

export default InterpretationPage;
